<template>
    <section class='natification'>
        <section class='main'>
            <div><img src="../../../assets/chatu.png" alt="" class='chatu'></div>
            <div class='msg'>{{msg}}</div>
        </section>
    </section>
</template>

<script>

  export default {
    props: {
      msg: String
    },
    name: '',
    mounted () {
      this.$nextTick(() => {
        let {top} = this.$el.getBoundingClientRect()
        let bodyHeight = document.documentElement.clientHeight
        let n_height = bodyHeight - top - 50
        this.$el.style.height = n_height + 'px'
      })
    },
    components: {}
  }
</script>

<style lang="scss" scoped type="text/css">
    @import "notification.scss";
</style>